/**
 * the enum for gender
 */
export const gender = {
    Male:"בנים",
    Female:"בנות",
    Both: "גם וגם"
}